import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/auth",
    meta: { title: "Autenticación - Viaggi Sellers" },
    name: "auth",
    component: () => import("../views/AuthView.vue"),
  },
  {
    path: "/",
    name: "home",
    component: () => import("../views/HomeView.vue"),
    redirect: "/reservas",
    children: [
      {
        path: "/reservas",
        meta: { title: "Reservas - Viaggi Sellers" },
        name: "reservas",
        component: () => import("../views/ReservasView.vue"),
      },
      {
        path: "/reserva/:idReserva",
        meta: { title: "Detalle de reserva - Viaggi Sellers" },
        name: "reserva",
        component: () => import("../views/ReservaView.vue"),
      },
      {
        path: "/documentos",
        meta: { title: "Documentos - Viaggi Sellers" },
        name: "documentos",
        component: () => import("../views/DocumentosView.vue"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to) => {
  document.title = to.meta?.title ?? "Viaggi Sellers";
});

export default router;
